import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { getTransactions } from "../../../../../../controllers/company/cashless/TransactionsController";
import CashlessTransactionsDataTable from "./dataTable";

export default function CashlessTransactions({economy})
{
    const [transactions,setTransactions] = useState([]);

    useEffect(()=>{
        handleGetTransactions();
    },[]);

    const handleGetTransactions = async () => {
        const response = await getTransactions(economy.uuid);
        if(response.success === true)
        {
            setTransactions(response.data.transactions);
        }
    }

    return(
        <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {
                    transactions.length > 0
                    ?<CashlessTransactionsDataTable transactions={transactions}/>
                    :null
                }
                
            </Grid>
        </Grid>
    )
}